<template>
  <Modal ref="modal" :small="false" @show="cargar">
    <h2 class="box__title extras-mg-miembros__titulo">
      Miembros de «{{ datos?.recurso?.nombre || nombre }}»
    </h2>
    <p class="extras-mg-miembros__sub">
      {{ tipo === 'tabla' ? 'Tabla' : 'Base de datos' }}
      <template v-if="datos && tipo === 'tabla'">
        de {{ datos.recurso.aplicacion.nombre }}</template
      >
      · Lo que se ponga aquí gana sobre el rol del espacio de trabajo{{
        tipo === 'tabla' ? ' y el de la base' : ''
      }}.
    </p>

    <Error :error="error"></Error>

    <div v-if="cargando && !datos" class="loading"></div>

    <template v-else-if="datos">
      <form class="extras-mg-miembros__invitar" @submit.prevent="invitar">
        <FormInput
          v-model="correo"
          class="extras-mg-miembros__correo"
          placeholder="correo@mandalagroup.com"
          type="email"
          :disabled="invitando"
        />
        <Dropdown
          v-model="rolInvitacion"
          class="extras-mg-miembros__rol-invitacion"
          :show-search="false"
          fixed-items
        >
          <DropdownItem
            v-for="rol in rolesParaInvitar"
            :key="rol"
            :name="nombres[rol]"
            :value="rol"
            :description="descripciones[rol]"
          ></DropdownItem>
        </Dropdown>
        <Button
          type="primary"
          :loading="invitando"
          :disabled="invitando || !correoValido"
        >
          Invitar
        </Button>
      </form>
      <p class="extras-mg-miembros__ayuda">
        Si la persona no está en el espacio de trabajo le llega la invitación
        por correo y, al aceptarla, solo ve esta
        {{ tipo === 'tabla' ? 'tabla' : 'base' }}.
      </p>

      <FormInput
        v-if="datos.miembros.length > 8"
        v-model="filtro"
        class="extras-mg-miembros__filtro"
        icon-left="iconoir-search"
        placeholder="Buscar persona..."
      />

      <ul class="extras-mg-miembros__lista">
        <li
          v-for="m in miembrosFiltrados"
          :key="m.id"
          class="extras-mg-miembros__fila"
        >
          <Avatar
            rounded
            size="medium"
            :initials="$filters.nameAbbreviation(m.nombre || m.correo)"
          ></Avatar>
          <div class="extras-mg-miembros__quien">
            <div class="extras-mg-miembros__nombre">
              {{ m.nombre || m.correo }}
              <span v-if="m.id === yoId" class="extras-mg-miembros__tu">(tú)</span>
            </div>
            <div class="extras-mg-miembros__correo-texto">{{ m.correo }}</div>
          </div>
          <div class="extras-mg-miembros__rol">
            <Dropdown
              v-if="m.editable && m.id !== yoId"
              :value="m.explicito || HEREDADO"
              :show-search="false"
              fixed-items
              :disabled="guardando === m.id"
              @input="asignar(m, $event)"
            >
              <DropdownItem
                :name="'Como en ' + origenPadre + ' (' + nombreHeredado(m) + ')'"
                :value="HEREDADO"
              ></DropdownItem>
              <DropdownItem
                v-for="rol in datos.yo.roles_que_doy"
                :key="rol"
                :name="nombres[rol]"
                :value="rol"
                :description="descripciones[rol]"
              ></DropdownItem>
              <!-- "Solo sus asuntos" no se da desde aqui: lo pone estar en
                   Personas. Se ensena para que la lista diga lo que hay. -->
              <DropdownItem
                v-if="m.explicito === ASIGNADO"
                :name="nombres[ASIGNADO]"
                :value="ASIGNADO"
                :description="descripciones[ASIGNADO]"
                disabled
              ></DropdownItem>
            </Dropdown>
            <span v-else class="extras-mg-miembros__rol-fijo">
              {{ m.efectivo_nombre }}
            </span>
            <span class="extras-mg-miembros__origen">{{ textoOrigen(m) }}</span>
          </div>
        </li>
      </ul>

      <template v-if="datos.pendientes.length">
        <h3 class="extras-mg-miembros__subtitulo">Invitaciones pendientes</h3>
        <ul class="extras-mg-miembros__lista">
          <li
            v-for="p in datos.pendientes"
            :key="'p' + p.id"
            class="extras-mg-miembros__fila"
          >
            <Avatar rounded size="medium" icon="iconoir-mail"></Avatar>
            <div class="extras-mg-miembros__quien">
              <div class="extras-mg-miembros__nombre">{{ p.correo }}</div>
              <div class="extras-mg-miembros__correo-texto">
                Entrará como {{ nombres[p.rol] }}
              </div>
            </div>
            <ButtonText type="secondary" @click="cancelar(p)">
              Cancelar
            </ButtonText>
          </li>
        </ul>
      </template>
    </template>
  </Modal>
</template>

<script>
/**
 * "Gestionar miembros" de una base o una tabla: quién entra y con qué rol.
 *
 * Lo abre el admin del espacio o el Encargado. El servidor es quien decide qué
 * roles puede dar cada uno (roles_que_doy) y a quién puede tocar (editable);
 * aquí solo se pinta lo que manda.
 */
import modal from '@baserow/modules/core/mixins/modal'
import error from '@baserow/modules/core/mixins/error'
import RolesService from '@extras_mg/services/roles'
import {
  ASIGNADO,
  DESCRIPCIONES,
  ENCARGADO,
  MIEMBRO,
  miembroDe,
  NOMBRES,
} from '@extras_mg/utils/roles'

const HEREDADO = '__heredado__'

export default {
  name: 'GestionarMiembrosModal',
  mixins: [modal, error],
  props: {
    // 'aplicacion' o 'tabla'
    tipo: { type: String, required: true },
    recursoId: { type: Number, required: true },
    nombre: { type: String, default: '' },
  },
  data() {
    return {
      HEREDADO,
      ASIGNADO,
      datos: null,
      cargando: false,
      guardando: null,
      invitando: false,
      correo: '',
      rolInvitacion: 'EDITOR',
      filtro: '',
      descripciones: DESCRIPCIONES,
    }
  },
  computed: {
    nombres() {
      // El rol que se da aqui se lee con el nombre: "Miembro de CANCÚN".
      return {
        ...NOMBRES,
        [ENCARGADO]: miembroDe(this.datos?.recurso?.nombre || this.nombre),
      }
    },
    yoId() {
      return this.$store.getters['auth/getUserId']
    },
    origenPadre() {
      return this.tipo === 'tabla' ? 'la base' : 'el espacio'
    },
    rolesParaInvitar() {
      // Invitar con "Sin acceso" no tiene sentido: seria invitar a no ver nada.
      return (this.datos?.yo?.roles_que_doy || []).filter(
        (r) => r !== 'SIN_ACCESO'
      )
    },
    correoValido() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.correo.trim())
    },
    miembrosFiltrados() {
      const f = this.filtro.trim().toLowerCase()
      const lista = this.datos?.miembros || []
      if (!f) return lista
      return lista.filter((m) =>
        `${m.nombre} ${m.correo}`.toLowerCase().includes(f)
      )
    },
  },
  methods: {
    /**
     * El servidor contesta nuestros errores con un `detail` ya en español
     * ("Ese rol no lo puedes dar tú."): se enseña ese y no el genérico.
     */
    mostrarError(e) {
      const detalle = e?.response?.data?.detail
      if (detalle && typeof detalle === 'string') {
        e.handler?.handled?.()
        this.showError('No se pudo', detalle)
      } else {
        this.handleError(e)
      }
    },
    async cargar() {
      this.cargando = true
      this.hideError()
      try {
        const { data } = await RolesService(this.$client).obtener(
          this.tipo,
          this.recursoId
        )
        this.datos = data
        if (!this.rolesParaInvitar.includes(this.rolInvitacion)) {
          this.rolInvitacion = this.rolesParaInvitar[0] || 'LECTOR'
        }
      } catch (e) {
        this.mostrarError(e)
      }
      this.cargando = false
    },
    nombreHeredado(m) {
      // Lo que tendria sin excepcion aqui: el de la base (en una tabla) o el
      // del espacio.
      if (this.tipo === 'tabla' && m.rol_base) {
        return m.rol_base === ENCARGADO
          ? miembroDe(this.datos?.recurso?.aplicacion?.nombre)
          : NOMBRES[m.rol_base]
      }
      if (m.supervision) return 'Supervisor (oculto)'
      if (m.rol_espacio === 'ADMIN') return 'Admin'
      if (m.rol_espacio === 'LECTOR') return 'Lector'
      if (m.rol_espacio === 'SIN_ACCESO') return 'Sin acceso'
      return NOMBRES[MIEMBRO]
    },
    textoOrigen(m) {
      if (m.origen === 'tabla') return this.tipo === 'tabla' ? 'en esta tabla' : ''
      if (m.origen === 'base') {
        return this.tipo === 'tabla' ? 'por la base' : 'en esta base'
      }
      return 'por el espacio'
    },
    async asignar(m, valor) {
      const rol = valor === HEREDADO ? null : valor
      if (rol === (m.explicito || null) || rol === ASIGNADO) return
      this.guardando = m.id
      this.hideError()
      try {
        const { data } = await RolesService(this.$client).asignar(
          this.tipo,
          this.recursoId,
          m.id,
          rol
        )
        this.datos = data
        this.$store.dispatch('toast/success', {
          title: 'Acceso actualizado',
          message: `${m.nombre || m.correo}: ${
            rol ? this.nombres[rol] : 'como en ' + this.origenPadre
          }`,
        })
      } catch (e) {
        this.mostrarError(e)
      }
      this.guardando = null
    },
    async invitar() {
      if (!this.correoValido) return
      this.invitando = true
      this.hideError()
      try {
        const urlBase = `${this.$config.public.baserowEmbeddedShareUrl}/workspace-invitation`
        const { data } = await RolesService(this.$client).invitar(
          this.tipo,
          this.recursoId,
          this.correo.trim(),
          this.rolInvitacion,
          urlBase
        )
        this.datos = data
        this.$store.dispatch('toast/success', {
          title: 'Listo',
          message: `${this.correo.trim()} entra como ${this.nombres[this.rolInvitacion]}.`,
        })
        this.correo = ''
      } catch (e) {
        this.mostrarError(e)
      }
      this.invitando = false
    },
    async cancelar(p) {
      this.hideError()
      try {
        const { data } = await RolesService(this.$client).cancelarPendiente(p.id)
        this.datos = data
      } catch (e) {
        this.mostrarError(e)
      }
    },
  },
}
</script>

<style lang="scss">
/* Sin colores fijos: build-theme.py invierte cualquier hex del CSS compilado,
   así que todo sale de currentColor y opacidades y sirve en claro y oscuro. */
.extras-mg-miembros__titulo {
  margin-bottom: 4px;
  overflow-wrap: anywhere;
}

.extras-mg-miembros__sub,
.extras-mg-miembros__ayuda {
  font-size: 13px;
  margin: 0 0 16px;
  opacity: 0.7;
}

.extras-mg-miembros__ayuda {
  margin: 6px 0 16px;
  font-size: 12px;
}

.extras-mg-miembros__invitar {
  align-items: center;
  display: flex;
  gap: 8px;
}

.extras-mg-miembros__correo {
  flex: 1;
  min-width: 0;
}

.extras-mg-miembros__rol-invitacion {
  flex: 0 0 150px;
}

.extras-mg-miembros__filtro {
  margin-bottom: 8px;
}

.extras-mg-miembros__subtitulo {
  font-size: 14px;
  font-weight: 600;
  margin: 20px 0 6px;
}

.extras-mg-miembros__lista {
  list-style: none;
  margin: 0;
  max-height: 50vh;
  overflow-y: auto;
  padding: 0;
}

.extras-mg-miembros__fila {
  align-items: center;
  border-top: 1px solid rgba(128, 128, 128, 0.2);
  display: flex;
  gap: 12px;
  padding: 10px 2px;
}

.extras-mg-miembros__quien {
  flex: 1;
  min-width: 0;
}

.extras-mg-miembros__nombre {
  font-size: 14px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.extras-mg-miembros__tu,
.extras-mg-miembros__correo-texto,
.extras-mg-miembros__origen {
  font-size: 12px;
  opacity: 0.6;
}

.extras-mg-miembros__correo-texto {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.extras-mg-miembros__rol {
  align-items: flex-end;
  display: flex;
  flex: 0 0 230px;
  flex-direction: column;
  gap: 2px;
}

.extras-mg-miembros__rol .dropdown {
  width: 100%;
}

.extras-mg-miembros__rol-fijo {
  font-size: 13px;
  font-weight: 500;
  padding: 6px 0;
}

@media (max-width: 640px) {
  .extras-mg-miembros__invitar,
  .extras-mg-miembros__fila {
    flex-wrap: wrap;
  }

  .extras-mg-miembros__rol {
    align-items: stretch;
    flex-basis: 100%;
  }
}
</style>
